import gql from "graphql-tag";
import AuthorFragments from '@/graphql/AuthorFragments';

const AUTHOR_DETAILS_FRAGMENT = AuthorFragments.authorDetailsFragment;

export default {
  getAuthor: gql`
    query getAuthor($id: ID!) {
      author(id: $id) {
        ...AuthorDetails
      }
    }
    ${AUTHOR_DETAILS_FRAGMENT}
  `,

  getAuthors: gql`
    query getAuthors($first: Int, $after: String, $name: String) {
      authors(first: $first, after: $after, name: $name) {
        edges {
          node {
            ...AuthorDetails
          }
          cursor
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        totalCount
      }
    }
    ${AUTHOR_DETAILS_FRAGMENT}
  `,

  addAuthor: gql`
    mutation addAuthor(
      $name: String!
      $bio: String
      $imageUrl: String
      $websiteUrl: String
      $twitterHandle: String
      $instagramHandle: String
      $tiktokHandle: String
      $facebookHandle: String
      $youtubeHandle: String
    ) {
      createAuthor(
        input: {
          name: $name
          bio: $bio
          imageUrl: $imageUrl
          websiteUrl: $websiteUrl
          twitterHandle: $twitterHandle
          instagramHandle: $instagramHandle
          tiktokHandle: $tiktokHandle
          facebookHandle: $facebookHandle
          youtubeHandle: $youtubeHandle
        }
      ) {
        author {
          ...AuthorDetails
        }
      }
    }
    ${AUTHOR_DETAILS_FRAGMENT}
  `,

  updateAuthor: gql`
    mutation updateAuthor(
      $id: ID!
      $name: String
      $bio: String
      $imageUrl: String
      $websiteUrl: String
      $twitterHandle: String
      $instagramHandle: String
      $tiktokHandle: String
      $facebookHandle: String
      $youtubeHandle: String
    ) {
      updateAuthor(
        input: {
          id: $id
          name: $name
          bio: $bio
          imageUrl: $imageUrl
          websiteUrl: $websiteUrl
          twitterHandle: $twitterHandle
          instagramHandle: $instagramHandle
          tiktokHandle: $tiktokHandle
          facebookHandle: $facebookHandle
          youtubeHandle: $youtubeHandle
        }
      ) {
        author {
          ...AuthorDetails
        }
      }
    }
    ${AUTHOR_DETAILS_FRAGMENT}
  `,

  deleteAuthor: gql`
    mutation deleteAuthor($input: deleteAuthorInput!) {
      deleteAuthor(input: $input) {
        author {
          id
        }
      }
    }
  `,
};
